import { render } from "./PersonalDetailMobile.vue?vue&type=template&id=0cc3f332&scoped=true"
import script from "./PersonalDetailMobile.vue?vue&type=script&lang=js"
export * from "./PersonalDetailMobile.vue?vue&type=script&lang=js"

import "./PersonalDetailMobile.vue?vue&type=style&index=0&id=0cc3f332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc3f332"]])

export default __exports__